import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  Alert,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  addroles,
  allpermissions,
} from "../../components/funtionsBD/Mainservice";
import { AddHeader } from "../../components/AddHeader";
import { useNavigate } from "react-router-dom";

export const AddRole = () => {
  const [plist, setplist] = useState();
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const Navigate = useNavigate();

  useEffect(() => {
    getpermission();
  }, []);

  const getpermission = async () => {
    try {
      const response = await allpermissions();
      console.log(response);
      setplist(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = `${t("require")}`;
    } else if (values.name.length > 100) {
      errors.name = `${t("must")}`;
    }

    if (!values.permission) {
      errors.permission = `${t("require")}`;
    }

    return errors;
  };

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleadd = async (values, { resetForm }) => {
    try {
      const response = await addroles(values.name, values.permission);
      setsuccess(response.data.message);
      setOpen(true);
      resetForm();
      Navigate("/Roles");
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      permission: [],
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handleadd(values, { resetForm });
    },
  });

  return (
    <div id="adminRoot">
      <AddHeader title={t("addrole")} />

      <form className="add-exercise" onSubmit={formik.handleSubmit}>
        <div className="input-details">
          <div className="input-detail">
            <label htmlFor=""> {t("rolename")}</label>
            <input
              placeholder={t("writename")}
              type="text"
              value={formik.values.name}
              name="name"
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.name ? (
            <div className="validation_error">{formik.errors.name}</div>
          ) : null}
        </div>
        <div className="input-details">
          <div className="input-detail">
            <label htmlFor=""> {t("permission")}</label>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              name="permission"
              value={formik.values.permission}
              onChange={formik.handleChange}
              sx={{
                background: "#fff",
                fontSize: "13px",
                fontFamily: "Poppins",
              }}
              input={<OutlinedInput label={t("permissions")} />}
            >
              {plist?.map((name) => (
                <MenuItem
                  key={name.per_id}
                  value={name.per_id}
                  sx={{
                    fontSize: "13px",
                    fontFamily: "Poppins",
                    borderBottom: "1px solid #f5f5f5",
                    background: "#f4f5f6",
                  }}
                >
                  {name.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          {formik.errors.name ? (
            <div className="validation_error">{formik.errors.name}</div>
          ) : null}
        </div>
        <div className="input-detail">
          <button className="w-100" type="submit">
            {t("createrole")}
          </button>
        </div>
        <Snackbar
          open={open}
          autoHideDuration={3000}
          onClose={closealert}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
      </form>
    </div>
  );
};
